module.exports = __webpack_public_path__ + "img/ico_cs.f8f372c5.svg";